import { type Dtos } from "@inrev/common";
import { ActionMenu, Icon } from "../../../../primitives";
import { PRO_CON_IMPORTANCE_LABELS, PRO_CON_IMPORTANCES } from "../../decisioningLabels";
import { ItemActionMenu } from "../ItemActionMenu";

export type FactorCardMenuProps = {
	factorName: string;
	importance: Dtos.Decisioning.ProConImportance;
	/** While the item is still saving: the trigger is disabled and the menu cannot open. */
	disabled: boolean;
	onEdit: () => void;
	onConnect: () => void;
	onRequestData: () => void;
	onRetire: () => void;
	onDelete: () => void;
	onImportanceChange: (importance: Dtos.Decisioning.ProConImportance) => void;
	testId: string;
};

/** The ⋯ menu. Importance changes only from here; there is no dropdown on the card. */
export const FactorCardMenu = ({
	factorName,
	importance,
	disabled,
	onEdit,
	onConnect,
	onRequestData,
	onRetire,
	onDelete,
	onImportanceChange,
	testId,
}: FactorCardMenuProps) =>
	disabled ? (
		<button
			type="button"
			disabled
			aria-label={`Actions for ${factorName} (saving)`}
			title="Saving…"
			data-testid={`${testId}-trigger`}
			className="inline-flex size-6 cursor-not-allowed items-center justify-center rounded-[6px] text-tertiary opacity-0 transition-opacity duration-[120ms] group-hover/item:opacity-50"
		>
			<Icon type="ellipsis-horizontal" size="mini" />
		</button>
	) : (
		<ItemActionMenu itemName={factorName} testId={testId}>
			<ActionMenu.Item onClick={onEdit}>Edit</ActionMenu.Item>
			<ActionMenu.Item onClick={onConnect}>Connect factor</ActionMenu.Item>
			<ActionMenu.Item onClick={onRequestData}>Request data</ActionMenu.Item>
			<ActionMenu.Item tone="warning" onClick={onRetire}>
				Retire
			</ActionMenu.Item>
			<ActionMenu.Item tone="danger" onClick={onDelete}>
				Delete
			</ActionMenu.Item>
			<ActionMenu.Divider />
			<ActionMenu.Label>Importance</ActionMenu.Label>
			<ActionMenu.PillRow>
				{PRO_CON_IMPORTANCES.map((level) => (
					<ActionMenu.Pill
						key={level}
						selected={level === importance}
						onClick={() => onImportanceChange(level)}
					>
						{PRO_CON_IMPORTANCE_LABELS[level]}
					</ActionMenu.Pill>
				))}
			</ActionMenu.PillRow>
		</ItemActionMenu>
	);
